<template>
    <div class="w3-container w3-responsive">

      <!-- 加载状态 -->
      <div v-if="loading" class="w3-panel w3-green w3-display-container">
        <span class="w3-button w3-large w3-display-topright" @click="loading = false">×</span>
        <p>loading...</p>
      </div>
  
      <!-- 错误提示 -->
      <div v-if="error" class="w3-panel w3-red">
        <p>{{ error }}</p>
      </div>
      <!-- 数据列表 -->
      <table class="w3-table w3-striped w3-bordered w3-border w3-hoverable w3-white">
        <thead>
        <tr class="w3-green">
          <th>AppId</th>
          <th>Msg</th>
          <th>Time</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="item in list" :key="item.RecordId" class="w3-padding" @click="toCS(item.f)">
          <td class="w3-text-grey">{{ item.f}}</td>
          <td class="w3-text-grey">{{ item.c }}</td>
          <td class="w3-text-grey">{{ $filters.formatDate(item.tm) }}</td>
        </tr>
        <tr>
          <td colspan="4" class="w3-text-grey w3-center">Total {{ list.length }} Records</td>
        </tr>
      </tbody>
      </table>
    </div>
  </template>
  
  <script>
 import axios from 'axios';

export default {
  data() {
    return {

      list: [],
      loading: false,
      error: '',
      userName: '',
      userPass: ''
    };
  },
  created() {

    const query = this.$route.query;

    if(query.u && query.p) {
      sessionStorage.setItem('userName', query.u);
      sessionStorage.setItem('userPass', query.p);
    }
    this.userName = sessionStorage.getItem('userName');
    this.userPass = sessionStorage.getItem('userPass');
    if(this.userName && this.userPass) {
        this.fetchData();
    } else {
      this.$router.push('/login');
    }
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = '';
      try {

        const response = await axios.get(`${this.$apiUrl}/getCSList?username=${this.userName}&t=${this.userPass}`);
       
        if(response.data.code == 200){
          this.list = response.data.result;
        }else if(response.data.code == 300) {
          this.error = response.data.result;
        }else if(response.data.code == 400){
          this.$router.push('/login?err=1');
        }else if(response.data.code == 500){
          this.error = response.data.result;
        } 

      } catch (err) {
        this.error = '获取数据失败，请稍后重试。';
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    toCS(f){
      this.$router.push({ path: '/cs', query: { u: this.userName, p: this.userPass, to: f } });
    }
  }
};
  </script>
  
  <style scoped>
  /* 可选：添加自定义样式覆盖或补充 W3.CSS */
  .w3-container {
    margin: 0px auto;
    padding: 0px;
  }
  
  .w3-ul li {
    transition: background-color 0.3s;
  }
  .w3-ul li:hover {
    background-color: #f0f0f0;
  }
  </style>